var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemEmptyImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 202,
  height: 200,
  fill: "none",
  viewBox: "0 0 202 200",
  role: "img"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 202,
  height: 200,
  fill: "#F9FAFC",
  rx: 8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 8,
  x: 92,
  y: 28,
  fill: "#E9EAEB",
  rx: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 8,
  x: 48,
  y: 28,
  fill: "#E9EAEB",
  rx: 4
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 8,
  x: 20,
  y: 160,
  fill: "#E9EAEB",
  rx: 4
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 84,
  height: 8,
  x: 20,
  y: 172,
  fill: "#E9EAEB",
  rx: 4
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 162,
  height: 100,
  x: 20,
  y: 52,
  fill: "#E9EAEB",
  rx: 8
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 12,
  fill: "#E9EAEB"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 92,
  r: 4,
  fill: "#F9FAFC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFC",
  d: "m56.981 106.957-21.577 21.631c-1.258 1.26-.365 3.412 1.416 3.412h128.398c1.775 0 2.67-2.141 1.423-3.405L124.206 85.58a2 2 0 0 0-2.969.134l-32.15 39.092a2 2 0 0 1-2.677.378L59.53 106.72a2 2 0 0 0-2.549.237"
})));
export default SvgGemEmptyImage;